import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
import api from "./api";

const readToken = () => {
  const raw = localStorage.getItem("token");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return raw; // token gravado como string crua
  }
};

// Uma renovação por vez. Sem isso, cada componente com socket (são mais de dez)
// dispararia seu próprio /auth/refresh_token no mesmo instante.
let renovacaoEmCurso = null;

const renovarToken = () => {
  if (!renovacaoEmCurso) {
    renovacaoEmCurso = api
      .post("/auth/refresh_token")
      .then(({ data }) => {
        if (data?.token) {
          localStorage.setItem("token", JSON.stringify(data.token));
          return data.token;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        renovacaoEmCurso = null;
      });
  }
  return renovacaoEmCurso;
};

/**
 * Abre uma conexão Socket.IO autenticada.
 *
 * O token do handshake é lido uma vez, quando a conexão é criada — mas o access
 * token vive 15 minutos. Toda reconexão depois disso (restart do backend,
 * deploy, queda de rede, notebook que dormiu) reenviava o mesmo token vencido,
 * o servidor derrubava a conexão e o tempo real morria em silêncio: a tela
 * continuava enviando mensagens pelo HTTP, que o axios renova sozinho, e nada
 * mais chegava até alguém apertar F5.
 *
 * Aqui o token é relido a cada tentativa de reconexão, e uma recusa do servidor
 * dispara a renovação antes de tentar de novo.
 */
function connectToSocket() {
  const socket = openSocket(getBackendUrl(), {
    // "flashsocket" saiu: é transporte do socket.io 0.9, não existe mais no v3.
    transports: ["websocket", "polling"],
    query: { token: readToken() }
  });

  // O handshake da reconexão usa `socket.io.opts.query` — atualizar aqui é o
  // que faz a nova tentativa levar o token atual em vez do original.
  socket.io.on("reconnect_attempt", () => {
    socket.io.opts.query = { token: readToken() };
  });

  // O servidor avisa antes de encerrar por token inválido. Renovamos e
  // reconectamos; se a renovação falhar, a sessão acabou de verdade e quem
  // trata isso é o interceptor do axios.
  socket.on("unauthorized", async (dados) => {
    // Sessão substituída não se resolve renovando token: o servidor vai
    // recusar de novo. Insistir geraria um laço de reconexão silencioso.
    if (dados?.reason === "session_replaced") return;

    const token = await renovarToken();
    if (!token) return;
    socket.io.opts.query = { token };
    socket.connect();
  });

  return socket;
}

export default connectToSocket;
